import { useEffect, useMemo, useState } from "react";
import { Button, Col } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faListCheck,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { APISD } from "../../../../../../config/apisd";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../NotificationToast/ToastError";

export default function TipeKegiatanTab({
  selectedMatpel,
  selectedSemesterId,
  selectedAcademicYearId,
  getToken,
  getUserId,
  getBranchId,
  getSchoolId,
  nameCollator,
  ToastSuccess,
  ToastError,
  onOpenAspek,
}) {
  const [activityData, setActivityData] = useState([]);
  const [selectedKelasId, setSelectedKelasId] = useState("");
  const [searchActivity, setSearchActivity] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [editActivityId, setEditActivityId] = useState(null);

  const [formActivity, setFormActivity] = useState({
    name_activities: "",
    input_type: 0,
  });

  const [isFetching, setIsFetching] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deletingActivityId, setDeletingActivityId] = useState(null);

  const cleanStorageValue = (value) => {
    return (value || "")
      .toString()
      .replace(/[|&;$%@"<>()+,]/g, "");
  };

  const resolveToken = () => {
    if (typeof getToken === "function") {
      return getToken() || "";
    }

    return localStorage.getItem("token") || "";
  };

  const resolveUserId = () => {
    let userId = "";

    if (typeof getUserId === "function") {
      try {
        userId = getUserId() || "";
      } catch (error) {
        userId = "";
      }
    }

    return cleanStorageValue(
      userId ||
        localStorage.getItem("id_admin") ||
        localStorage.getItem("user_id") ||
        localStorage.getItem("id_user") ||
        localStorage.getItem("userId") ||
        ""
    );
  };

  const resolveBranchId = () => {
    if (typeof getBranchId === "function") {
      return (
        getBranchId() ||
        localStorage.getItem("ysb_branch_id") ||
        ""
      );
    }

    return localStorage.getItem("ysb_branch_id") || "";
  };

  const resolveSchoolId = () => {
    if (typeof getSchoolId === "function") {
      return (
        getSchoolId() ||
        localStorage.getItem("ysb_school_id") ||
        ""
      );
    }

    return localStorage.getItem("ysb_school_id") || "";
  };

  const showSuccess = (options) => {
    ToastSuccess.fire({
      icon: "success",
      title: options?.title || "Data berhasil disimpan",
    });
  };

  const showError = (options) => {
    ToastError.fire({
      icon: "error",
      title: options?.title || "Terjadi kesalahan",
    });
  };

  const collator = useMemo(() => {
    return (
      nameCollator ||
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      })
    );
  }, [nameCollator]);

  const getArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data)) {
      return responseData.data.data;
    }

    if (Array.isArray(responseData?.data?.rows)) {
      return responseData.data.rows;
    }

    if (Array.isArray(responseData?.data)) {
      return responseData.data;
    }

    if (Array.isArray(responseData?.result?.data)) {
      return responseData.result.data;
    }

    if (Array.isArray(responseData?.result)) {
      return responseData.result;
    }

    if (Array.isArray(responseData)) {
      return responseData;
    }

    return [];
  };

  const kelasList = useMemo(() => {
    const rawKelasList = Array.isArray(
      selectedMatpel?.kelas_list
    )
      ? selectedMatpel.kelas_list
      : [];

    const rawAssignments = Array.isArray(
      selectedMatpel?.assignments
    )
      ? selectedMatpel.assignments
      : [];

    const mapKelas = new Map();

    [...rawKelasList, ...rawAssignments].forEach(
      (kelas) => {
        const kelasId =
          kelas?.ysb_kelas_id ||
          kelas?.kelas_id ||
          kelas?.id_kelas ||
          kelas?.id ||
          "";

        if (!kelasId) return;

        const existing =
          mapKelas.get(String(kelasId)) || {};

        mapKelas.set(String(kelasId), {
          ...existing,
          ...kelas,

          ysb_kelas_id: kelasId,

          ysb_grade_level_id:
            kelas?.ysb_grade_level_id ||
            existing?.ysb_grade_level_id ||
            selectedMatpel?.ysb_grade_level_id ||
            "",

          ysb_branch_id:
            kelas?.ysb_branch_id ||
            existing?.ysb_branch_id ||
            selectedMatpel?.ysb_branch_id ||
            "",

          ysb_school_id:
            kelas?.ysb_school_id ||
            existing?.ysb_school_id ||
            selectedMatpel?.ysb_school_id ||
            "",

          nama_kelas:
            kelas?.nama_kelas ||
            kelas?.name_kelas ||
            kelas?.name_class ||
            existing?.nama_kelas ||
            "-",
        });
      }
    );

    return [...mapKelas.values()].sort((a, b) =>
      collator.compare(
        (a?.nama_kelas || "").toString().trim(),
        (b?.nama_kelas || "").toString().trim()
      )
    );
  }, [selectedMatpel, collator]);


  const normalizeActivity = (item) => {
    return {
      id:
        item?.id ||
        item?.ysb_type_activity_id ||
        item?.type_activity_id ||
        "",

      ysb_branch_id: item?.ysb_branch_id || "",
      ysb_school_id: item?.ysb_school_id || "",
      ysb_academic_year_id:
        item?.ysb_academic_year_id || "",
      ysb_semester_id: item?.ysb_semester_id || "",
      ysb_grade_level_id:
        item?.ysb_grade_level_id || "",
      ysb_kelas_id: item?.ysb_kelas_id || "",
      ysb_matpel_id: item?.ysb_matpel_id || "",

      name_activities:
        item?.name_activities ||
        item?.name_activity ||
        item?.nama_kegiatan ||
        item?.nama_aktivitas ||
        "",

      name_kelas:
        item?.name_kelas ||
        item?.nama_kelas ||
        item?.name_class ||
        "",

      input_type:
        Number(item?.input_type) === 1 ? 1 : 0,

      raw: item,
    };
  };

  const resetForm = () => {
    setEditActivityId(null);

    setFormActivity({
      name_activities: "",
      input_type: 0,
    });
  };

  const getActivityData = async () => {
    if (!selectedKelasId) {
      setActivityData([]);
      setIsFetching(false);
      return;
    }

    setIsFetching(true);

    try {
      const token = resolveToken();

      const requestBody = {
        page: 1,
        limit: 1000,
        ascending: true,
        search: "",
        ysb_kelas_id: selectedKelasId,
        level:
          localStorage.getItem("level") || "developer",
      };

      const response = await APISD.request({
        method: "GET",
        url: "/api/type-activities",

        headers: {
          Authorization: token,
          "Content-Type": "application/json",
          Accept: "application/json",
        },

        data: requestBody,
      });

      const rows = getArrayFromResponse(
        response?.data
      ).map(normalizeActivity);

      setActivityData(rows);
    } catch (error) {
      console.log(
        "Gagal mengambil data tipe kegiatan:",
        error
      );

      setActivityData([]);

      showError({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal mengambil data tipe kegiatan",
      });
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    const availableKelasIds = kelasList
      .map((kelas) =>
        String(kelas?.ysb_kelas_id || "")
      )
      .filter(Boolean);

    setSelectedKelasId((currentId) => {
      if (
        currentId &&
        availableKelasIds.includes(String(currentId))
      ) {
        return currentId;
      }

      return availableKelasIds[0] || "";
    });

    setSearchActivity("");
    resetForm();
    setShowModal(false);
  }, [
    selectedMatpel?.row_key,
    selectedMatpel?.id,
    selectedMatpel?.ysb_matpel_id,
    kelasList,
  ]);

  useEffect(() => {
    if (selectedKelasId) {
      getActivityData();
    } else {
      setActivityData([]);
    }
  }, [
    selectedKelasId,
    selectedMatpel?.ysb_matpel_id,
    selectedMatpel?.id,
    selectedAcademicYearId,
    selectedSemesterId,
  ]);

  const filteredActivityData = useMemo(() => {
    const selectedMatpelId =
      selectedMatpel?.ysb_matpel_id ||
      selectedMatpel?.id ||
      "";

    const keyword = (searchActivity || "")
      .trim()
      .toLowerCase();

    const rows = (activityData || []).filter(
      (item) => {
        const sameKelas =
          !item?.ysb_kelas_id ||
          String(item.ysb_kelas_id) ===
            String(selectedKelasId);

        const sameMatpel =
          !item?.ysb_matpel_id ||
          !selectedMatpelId ||
          String(item.ysb_matpel_id) ===
            String(selectedMatpelId);

        const sameAcademicYear =
          !item?.ysb_academic_year_id ||
          !selectedAcademicYearId ||
          String(item.ysb_academic_year_id) ===
            String(selectedAcademicYearId);

        const sameSemester =
          !item?.ysb_semester_id ||
          !selectedSemesterId ||
          String(item.ysb_semester_id) ===
            String(selectedSemesterId);

        const matchSearch = !keyword
          ? true
          : (item?.name_activities || "")
              .toString()
              .toLowerCase()
              .includes(keyword);

        return (
          sameKelas &&
          sameMatpel &&
          sameAcademicYear &&
          sameSemester &&
          matchSearch
        );
      }
    );

    return [...rows].sort((a, b) =>
      collator.compare(
        (a?.name_activities || "")
          .toString()
          .trim(),
        (b?.name_activities || "")
          .toString()
          .trim()
      )
    );
  }, [
    activityData,
    searchActivity,
    selectedKelasId,
    selectedMatpel,
    selectedAcademicYearId,
    selectedSemesterId,
    collator,
  ]);

  const selectedKelas = useMemo(() => {
    return kelasList.find(
      (kelas) =>
        String(kelas?.ysb_kelas_id || "") ===
        String(selectedKelasId || "")
    );
  }, [kelasList, selectedKelasId]);

  const handleOpenAdd = () => {
    if (!selectedKelasId) {
      showError({
        icon: "error",
        title: "Kelas belum tersedia",
      });

      return;
    }

    resetForm();
    setShowModal(true);
  };

  const handleOpenEdit = (item) => {
    if (!item?.id) {
      showError({
        icon: "error",
        title: "ID tipe kegiatan tidak ditemukan",
      });

      return;
    }

    setEditActivityId(item.id);

    // setFormActivity({
    //   name_activities: item?.name_activities || "",
    // });

    setFormActivity({
      name_activities: item?.name_activities || "",
      input_type:
        Number(item?.input_type) === 1 ? 1 : 0,
    });

    setShowModal(true);
  };

  const handleCloseModal = () => {
    if (isSubmitting) return;

    setShowModal(false);
    resetForm();
  };


  const handleChangeForm = (event) => {
    const { name, value } = event.target;

    setFormActivity((previous) => ({
      ...previous,
      [name]:
        name === "input_type"
          ? Number(value)
          : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) return;

    const activityName = (
      formActivity.name_activities || ""
    ).trim();

    const matpelId =
      selectedMatpel?.ysb_matpel_id ||
      selectedMatpel?.id ||
      "";

    const branchId =
      selectedKelas?.ysb_branch_id ||
      selectedMatpel?.ysb_branch_id ||
      resolveBranchId();

    const schoolId =
      selectedKelas?.ysb_school_id ||
      selectedMatpel?.ysb_school_id ||
      resolveSchoolId();

    const gradeLevelId =
      selectedKelas?.ysb_grade_level_id ||
      selectedMatpel?.ysb_grade_level_id ||
      "";

    const userId = resolveUserId();
    const token = resolveToken();

    if (!matpelId) {
      showError({
        icon: "error",
        title: "Mata pelajaran belum dipilih",
      });

      return;
    }

    if (!selectedKelasId) {
      showError({
        icon: "error",
        title: "Kelas wajib dipilih",
      });

      return;
    }

    if (!activityName) {
      showError({
        icon: "error",
        title: "Nama kegiatan wajib diisi",
      });

      return;
    }

    if (!selectedAcademicYearId) {
      showError({
        icon: "error",
        title: "Tahun ajaran tidak ditemukan",
      });

      return;
    }

    if (!selectedSemesterId) {
      showError({
        icon: "error",
        title: "Semester tidak ditemukan",
      });

      return;
    }

    if (!branchId) {
      showError({
        icon: "error",
        title: "ID cabang tidak ditemukan",
      });

      return;
    }

    if (!schoolId) {
      showError({
        icon: "error",
        title: "ID sekolah tidak ditemukan",
      });

      return;
    }

    if (!gradeLevelId) {
      showError({
        icon: "error",
        title: "ID tingkatan tidak ditemukan",
      });

      return;
    }

    if (!userId) {
      showError({
        icon: "error",
        title:
          "ID user tidak ditemukan. Silakan login ulang.",
      });

      return;
    }

    const payload = {
      ysb_academic_year_id:
        selectedAcademicYearId,
      ysb_semester_id: selectedSemesterId,
      ysb_branch_id: branchId,
      ysb_school_id: schoolId,
      ysb_grade_level_id: gradeLevelId,
      ysb_kelas_id: selectedKelasId,
      ysb_matpel_id: matpelId,
      name_activities: activityName,

      input_type:
        Number(formActivity.input_type) === 1
          ? 1
          : 0,

      user_id: userId,
    };

    setIsSubmitting(true);

    try {
      let response;

      if (editActivityId) {
        response = await APISD.put(
          `/api/type-activities/${editActivityId}`,
          payload,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
      } else {
        response = await APISD.post(
          "/api/type-activities/store",
          payload,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
      }

      const isSuccess =
        response?.status === 200 ||
        response?.status === 201 

      if (isSuccess) {
        ToastSuccess.fire({
          icon: "success",
          title:
            response?.data?.message ||
            (editActivityId
              ? "Tipe kegiatan berhasil diubah"
              : "Tipe kegiatan berhasil disimpan"),
        });

       
        setShowModal(false);

        resetForm();

        await getActivityData();

        return;
      }

      ToastError.fire({
        icon: "error",
        title:
          response?.data?.message ||
          (editActivityId
            ? "Gagal mengubah tipe kegiatan"
            : "Gagal menyimpan tipe kegiatan"),
      });
    } catch (error) {
      console.log(
        editActivityId
          ? "Gagal mengubah tipe kegiatan:"
          : "Gagal menyimpan tipe kegiatan:",
        error
      );

      const validationMessage =
        error?.response?.data?.errors
          ? Object.values(error.response.data.errors)
              .flat()
              .join("\n")
          : "";

      ToastError.fire({
        icon: "error",
        title:
          validationMessage ||
          error?.response?.data?.message ||
          error?.message ||
          (editActivityId
            ? "Gagal mengubah tipe kegiatan"
            : "Gagal menyimpan tipe kegiatan"),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = (item) => {
    if (!item?.id) {
      showError({
        icon: "error",
        title: "ID tipe kegiatan tidak ditemukan",
      });

      return;
    }

    Swal.fire({
      title: "Apakah Kamu Yakin?",
      text: `Tipe kegiatan "${
        item?.name_activities || "-"
      }" akan dihapus`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      const token = resolveToken();

      setDeletingActivityId(item.id);

      try {
        const response = await APISD.delete(
          `/api/type-activities/${item.id}`,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        showSuccess({
          icon: "success",
          title:
            response?.data?.message ||
            "Tipe kegiatan berhasil dihapus",
        });

        await getActivityData();
      } catch (error) {
        console.log(
          "Gagal menghapus tipe kegiatan:",
          error
        );

        showError({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal menghapus tipe kegiatan",
        });
      } finally {
        setDeletingActivityId(null);
      }
    });
  };

  const handleOpenAspek = (item) => {
    if (typeof onOpenAspek === "function") {
      onOpenAspek(item);
      return;
    }

    Swal.fire({
      icon: "info",
      title: "Aspek Kegiatan",
      text: `Tipe kegiatan yang dipilih: ${
        item?.name_activities || "-"
      }`,
      confirmButtonText: "Tutup",
    });
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        backdrop={isSubmitting ? "static" : true}
        keyboard={!isSubmitting}
      >
        <form onSubmit={handleSubmit}>
          <Modal.Header
            closeButton={!isSubmitting}
          >
            <Modal.Title>
              <h5 className="mb-0">
                {editActivityId
                  ? "Edit Tipe Kegiatan"
                  : "Buat Tipe Kegiatan"}
              </h5>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="mt-4 label-group-form">
              <label className="label-name-form">
                Kelas
              </label>

              <input
                id="type-activity-class"
                className="label-input-form"
                type="text"
                value={selectedKelas?.nama_kelas || "-"}
                disabled
              />
            </div>

            <div className="mt-4 label-group-form">
              <label
                className="label-name-form"
                htmlFor="name_activities"
              >
                Nama Kegiatan
              </label>

              <input
                id="name_activities"
                className="label-input-form"
                autoFocus
                type="text"
                name="name_activities"
                placeholder="..."
                value={formActivity.name_activities}
                onChange={handleChangeForm}
                disabled={isSubmitting}
                maxLength={255}
              />
            </div>

            <div className="mt-3">
              <label
                style={{
                  display: "block",
                  marginBottom: 10,
                  color: "#3f5bea",
                  fontSize: 14,        
                }}
              >
                Jenis Penilaian
              </label>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "repeat(2, minmax(0, 1fr))",
                  gap: 12,
                  width: "100%",
                }}
              >
                {[
                  {
                    value: 0,
                    title: "Kuantitatif",
                    description: "Penilaian berupa angka",
                  },
                  {
                    value: 1,
                    title: "Deskriptif",
                    description:
                      "Penilaian berupa deskripsi atau teks",
                  },
                ].map((option) => {
                  const isSelected =
                    Number(formActivity.input_type) ===
                    option.value;

                  return (
                  
                    <label
                      key={option.value}
                      htmlFor={`input-type-${option.value}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 14,
                        width: "100%",
                        minWidth: 0,
                        minHeight: 96,
                        margin: 0,
                        padding: "18px 16px",
                        boxSizing: "border-box",
                        borderRadius: 12,
                        border: isSelected
                          ? "2px solid #4361ee"
                          : "1px solid #d9dee8",
                        backgroundColor: isSelected
                          ? "#f4f6ff"
                          : "#ffffff",
                        cursor: isSubmitting
                          ? "not-allowed"
                          : "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                    <input
                      id={`input-type-${option.value}`}
                      type="radio"
                      name="input_type"
                      value={option.value}
                      checked={isSelected}
                      onChange={handleChangeForm}
                      disabled={isSubmitting}
                      style={{
                        flexShrink: 0,
                        width: 18,
                        height: 18,
                        margin: 0,
                        accentColor: "#4361ee",
                        cursor: isSubmitting
                          ? "not-allowed"
                          : "pointer",
                      }}
                    />

                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        minWidth: 0,
                        textAlign: "left",
                      }}
                    >
                      <span
                        style={{
                          display: "block",
                          margin: 0,
                          marginBottom: 5,
                          color: "#343844",
                          fontSize: 15,
                          fontWeight: 700,
                          lineHeight: 1.25,
                        }}
                      >
                        {option.title}
                      </span>

                      <span
                        style={{
                          display: "block",
                          margin: 0,
                          color: "#858b98",
                          fontSize: 13,
                          fontWeight: 400,
                          lineHeight: 1.45,
                        }}
                      >
                        {option.description}
                      </span>
                    </span>
                  </label>
                  );
                })}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div
              className="d-flex"
              style={{
                justifyContent: "flex-end",
                gap: 10,
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              <Button
                type="button"
                className="btn btn-light"
                onClick={handleCloseModal}
                disabled={isSubmitting}
                style={{
                  borderRadius: 10,
                  fontWeight: 600,
                  padding: "8px 14px",
                }}
              >
                Batal
              </Button>

              <Button
                className="btn-modal-create"
                type="submit"
                disabled={isSubmitting}
                style={{
                  borderRadius: 12,
                  padding: "8px 14px",
                  boxShadow:
                    "0 10px 24px rgba(108,99,255,0.18)",
                  fontWeight: 600,
                }}
              >
                {isSubmitting
                  ? editActivityId
                    ? "Mengubah..."
                    : "Menyimpan..."
                  : editActivityId
                    ? "Simpan Perubahan"
                    : "Simpan"}
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>

      <div
        className="d-flex mt-4 mb-4"
        style={{
          gap: 12,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {/* <select
          className="at-input"
          value={selectedKelasId}
          onChange={(event) => {
            setSelectedKelasId(
              event.target.value
            );
            setSearchActivity("");
          }}
          style={{
            width: 280,
            maxWidth: "100%",
            background: "#fff",
            cursor:
              kelasList.length > 0
                ? "pointer"
                : "not-allowed",
          }}
          disabled={kelasList.length === 0}
        >
          {kelasList.length === 0 ? (
            <option value="">
              Kelas tidak tersedia
            </option>
          ) : (
            kelasList.map((kelas, index) => (
              <option
                key={
                  kelas?.ysb_kelas_id || index
                }
                value={
                  kelas?.ysb_kelas_id || ""
                }
              >
                {kelas?.nama_kelas || "-"}
              </option>
            ))
          )}
        </select> */}

         <div className="at-search">
          <input
            className="at-input"
            placeholder="Cari nama kegiatan"
            value={searchActivity}
            onChange={(event) =>
              setSearchActivity(
                event.target.value
              )
            }
          />
        </div>

        <div className="ml-auto">
          <button
            type="button"
            onClick={handleOpenAdd}
            className="btn btn-create mr-2"
            disabled={!selectedKelasId}
            style={{
              borderRadius: 12,
              padding: "8px 14px",
              boxShadow:
                "0 10px 24px rgba(108,99,255,0.18)",
              fontWeight: 600,
            }}
          >
            <FontAwesomeIcon icon={faPlus} />{" "}
            Buat Tipe Kegiatan
          </button>
        </div>
      </div>

     

      <Col xl="12" sm="12">
        <div className="mt-3 body-table">
          <table
            className="table table-hover custom-hover-table table-border-style"
            id="basic-datatable"
          >
            <thead>
              <tr>
                <th>Nama Kegiatan</th>

                <th
                  style={{
                    width: 320,
                    textAlign: "center",
                  }}
                >
                  Aksi
                </th>
              </tr>
            </thead>

            <tbody>
              {isFetching ? (
                <tr>
                  <td
                    colSpan="2"
                    className="text-center"
                    style={{ padding: 18 }}
                  >
                    Mengambil data tipe
                    kegiatan...
                  </td>
                </tr>
              ) : filteredActivityData.length >
                0 ? (
                filteredActivityData.map(
                  (row, index) => (
                    <tr
                      key={row?.id || index}
                    >
                      <td
                        style={{
                          lineHeight: "2",
                          fontWeight: 600,
                        }}
                      >
                        {row?.name_activities ||
                          "-"}
                      </td>

                      <td
                        style={{
                          textAlign: "center",
                          lineHeight: "2",
                        }}
                      >
                        <div
                          className="d-flex justify-content-center"
                          style={{
                            gap: 8,
                            flexWrap: "wrap",
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                              handleOpenAspek(row)
                            }
                            style={{
                              borderRadius: 8,
                              fontWeight: 600,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faListCheck}
                            />{" "}
                            Aspek
                          </button>

                          <button
                            type="button"
                            className="btn btn-sm btn-warning"
                            onClick={() =>
                              handleOpenEdit(row)
                            }
                            style={{
                              borderRadius: 8,
                              color: "#fff",
                              fontWeight: 600,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faPenToSquare}
                            />
                          </button>

                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() =>
                              handleDelete(row)
                            }
                            disabled={
                              deletingActivityId ===
                              row.id
                            }
                            style={{
                              borderRadius: 8,
                              fontWeight: 600,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                            />

                            {/* {deletingActivityId ===
                            row.id
                              ? " Menghapus..."
                              : " Hapus"} */}
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td
                    colSpan="2"
                    className="text-center"
                    style={{ padding: 20 }}
                  >
                    {selectedKelasId
                      ? "Data tipe kegiatan belum tersedia"
                      : "Pilih kelas terlebih dahulu"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Col>
    </>
  );
}